import {
  ApiConfig
} from "./chunk-LPIRJEMY.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/geo/location.ts
import { Exception } from "@wbk/logger";
var getGeoLocation = () => __async(void 0, null, function* () {
  var _a, _b;
  try {
    const baseApi = (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.geoApi;
    if (!baseApi) {
      throw new Error("GeoLocation API is not configured");
    }
    const data = yield fetch(baseApi);
    const response = yield data.json();
    return response;
  } catch (error) {
    throw new Exception({
      error,
      name: "getGeoLocationException"
    });
  }
});

export {
  getGeoLocation
};
//# sourceMappingURL=chunk-H3BAINZ7.mjs.map